"use client"
import React from 'react';

//import FormLayout from '../pages/FormLayout';

//import Input from '../pages/Input';
import Home from '../pages/Home';

import HomeGuest from '../pages/HomeGuest';
//import Demo from '../pages/Demo';
//import DemoTablaLocal from '../pages/DemoTablaLocal';

import Login from '../pages/Login';
import ReciboPago from '../pages/ReciboPago';

import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import EmptyPage from '../pages/EmptyPage';

//import Generica2 from '../pages/Generica2';
//import DatoMaestro from '../pages/DatoMaestro';
import FileDownload from '../pages/FileDownload';
import TableDemo from '../components/TableDemo';

import GeneratePdf from '../templates/GeneratePdf';
import Reporte from '../templates/Reporte';
import MedicionRA from '../pages/MedicionRA';

import FormatoPendiente from '../pages/FormatoPendiente';
import PublicURLShared from '../pages/PublicURLShared';
import GuestUserURL from '../pages/GuestUserURL';
import { usePathname } from 'next/navigation'


import LandingPageGuest from '../pages/LandingPageGuest';


const App = () => {

    console.log("app.js");

    let folderAPP = process.env.NEXT_PUBLIC_FOLDER_APP;

    if (typeof window !== undefined) {


        //let path = window.location.pathname;
        let path = usePathname();

        console.log("path, ", path, folderAPP + "/");

        switch (path) {

            case "/": //ok?
                return <PublicRoute component={Login} />;
                break;

            case "/home/": //ok
                return <PrivateRoute path={folderAPP + "/Home"} component={Home} />
                break;


            case "/reciboPago/": //ok
                return <PublicRoute component={ReciboPago} />
                break;

            case "/formatoPendiente/":
                return <PublicRoute component={FormatoPendiente} />
                break;

            case "/encuesta/":
                <PublicRoute path={folderAPP + "/encuesta"} component={PublicURLShared} />
                break;

            case "/l/": //ok
                return <PublicRoute path={folderAPP + "/l"} component={PublicURLShared} />
                break;

            //case "/external/":return <PublicRoute path={folderAPP + "/external"} component={GuestUserURL} />break;

            case "/credito/": //ok

                return <PublicRoute path={folderAPP + "/credito"} component={LandingPageGuest} />
                break;

            case "/homeguest/":

                return <PublicRoute path={folderAPP + "/HomeGuest"} component={HomeGuest} />
                break;

            case "/medicionRA/":
                return <PublicRoute path={folderAPP + "/medicionRA"} component={MedicionRA} />
                break;


            //case "/generica2/": return <PrivateRoute path={folderAPP + "/generica2"} component={Generica2} />break;

            //case "/datoMaestro/": return <PrivateRoute path={folderAPP + "/datoMaestro"} component={DatoMaestro} /> break;

            case "/file/":
                return <PrivateRoute path={folderAPP + "/file"} component={FileDownload} />
                break;

            case "/GeneratePdf/":
                return <PrivateRoute path={folderAPP + "/GeneratePdf"} component={GeneratePdf} />
                break;

            case "/report/": //ok
                return <PrivateRoute path={folderAPP + "/report"} component={Reporte} />
                break;

            //case "/Demo/": return <PrivateRoute path={folderAPP + "/Demo"} component={Demo} /> break;

            //case "/FormLayout/": return <PrivateRoute exact path={folderAPP + "/FormLayout"} component={FormLayout} /> break;



            //default:
            //return <PublicRoute path="*" component={EmptyPage} />
        }

    }
    else {
        return (<></>);
    }



}

export default App;